<div class="dialog">
  <div class="storage-alert">
    <app-svg src="/assets/icons/harddrive.svg"></app-svg>
  </div>

  <h1>Storage is Full</h1>
  @if (canManageStorage()) {
    <p>There is not enough space left. Upgrade your plan or get a storage add-on.</p>
    <a
      [routerLink]="'/a/settings/storage'"
      appButton
      name="manage-storage"
      location="out-of-storage-dialog"
      (click)="close()"
      color="primary"
      height="4"
      shape="round"
      size="3"
      spacing="full"
    >
      Manage Storage
    </a>
  } @else {
    <p>There is not enough space left. Contact an admin if you need more storage.</p>
    <button
      appButton
      name="ok"
      location="out-of-storage-dialog"
      (click)="close()"
      color="primary"
      height="4"
      shape="round"
      size="3"
      spacing="full"
    >
      Ok
    </button>
  }
</div>
